import { render, staticRenderFns } from "./TrashOrderFix.vue?vue&type=template&id=4c4cc974&scoped=true&"
import script from "./TrashOrderFix.vue?vue&type=script&lang=js&"
export * from "./TrashOrderFix.vue?vue&type=script&lang=js&"
import style0 from "./TrashOrderFix.vue?vue&type=style&index=0&id=4c4cc974&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cc974",
  null
  
)

export default component.exports